export class QueryString {
    static parse(str) {
        const pattern = /\??(.*?)=([^&]*)&?/gi;
        const query = {};
        let match;
        while (match = pattern.exec(str)) {
            query[encodeURIComponent(match[1])] = encodeURIComponent(match[2]);
        }
        return query;
    }
}


// WEBPACK FOOTER //
// ./src/helper/queryString.js